document.addEventListener("DOMContentLoaded", () => {
  let asideContainers = document.querySelectorAll('.wp-block-aside');
  if (asideContainers) {
    asideContainers.forEach((asideContainer) => {
      let body = asideContainer.querySelector('.wp-block-aside__body');
      let paragraphs = body.querySelectorAll('.wp-block-aside__text *');
      let toggle = body.querySelector('.button');

      if (toggle) {
        if (paragraphs && paragraphs.length > 0) {
          toggle.addEventListener('click', (event) => {
            toggle.classList.toggle('button--plus');
            toggle.classList.toggle('button--minus');

            if (body) {
              body.classList.toggle('wp-block-aside__body--active');
            }
            event.preventDefault();
          });
        } else {
          toggle.style.display = 'none';
        }
      }
    });
  }
});
